/**
 * Company information constants used across the site
 * for SEO schema markup and display purposes
 */

export const COMPANY_INFO = {
  name: 'Uppbeat',
  legalName: 'Music Vine Limited',
  foundingDate: '2021-01-18',
  url: 'https://uppbeat.io/',
  logo: 'https://cdn.uppbeat.io/images/schema-logo.png',
  registrationNumber: '09234137',
  email: 'hello@uppbeat.io',
} as const;

export const COMPANY_ADDRESS = {
  streetAddress: 'Tailors Corner, 1 Thirsk Row',
  city: 'Leeds',
  postalCode: 'LS1 4DP',
  country: 'United Kingdom',
  countryCode: 'UK',
} as const;

export const COMPANY_TERMS_URL = '/user-agreement';
export const COMPANY_PRIVACY_POLICY_URL = '/privacy-and-cookie-policy';

export const COMPANY_SOCIALS = [
  'https://www.instagram.com/UppbeatOfficial/',
  'https://www.facebook.com/UppbeatOfficial/',
  'https://twitter.com/UppbeatOfficial',
  'https://discord.gg/q5xaCqhGFC',
] as const;
